const constants = {
    devUrl: 'http://localhost:3001',
    prodUrl: 'https://mesto.webway.dev'
}

export default constants;
